import { connect } from 'react-redux'
import View from './LiveRadioLink'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const LiveRadioLink = connect(mapStateToProps)(View)

export default LiveRadioLink
